<button mat-menu-item (click)="toggleShowGrid.emit(!showGrid)" [class.active]="!!showGrid">
  <fa-icon [icon]="['fal', 'border-outer']" class="text-[16px] mr-2"></fa-icon>
  {{ showGrid ? 'Hide' : 'Show' }} grid
</button>
